import DatabaseSwitchboard from './DatabaseSwitchboard'

export { databaseSwitchboardPropTypes } from './DatabaseSwitchboard'

export default DatabaseSwitchboard
